
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_dm8gx_1a676_161",
  "has-items": "awsui_has-items_dm8gx_1a676_192",
  "no-padding": "awsui_no-padding_dm8gx_1a676_192",
  "dismiss-button": "awsui_dismiss-button_dm8gx_1a676_196",
  "token": "awsui_token_dm8gx_1a676_238",
  "token-box": "awsui_token-box_dm8gx_1a676_245",
  "token-box-readonly": "awsui_token-box-readonly_dm8gx_1a676_265",
  "token-box-disabled": "awsui_token-box-disabled_dm8gx_1a676_279"
};
  